import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-rise",
  "use": "icon-arrow-rise-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol viewBox=\"0 0 11 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-rise\">\n<path d=\"M7.1934 5.58325V11.3299C7.1934 11.6485 6.93328 11.9086 6.61475 11.9086H4.30015C3.98163 11.9086 3.7215 11.6485 3.7215 11.3299V5.58325H1.16801C0.849482 5.58325 0.589355 5.32577 0.589355 5.0046C0.589355 4.85064 0.650406 4.702 0.759234 4.59317L5.09381 0.261256C5.31943 0.0356359 5.68573 0.0356359 5.91135 0.261256L10.2433 4.59583C10.4689 4.82145 10.4689 5.18775 10.2433 5.41337C10.1344 5.5222 9.98579 5.58325 9.83184 5.58325H7.1934Z\" fill=\"#0E9979\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-rise.svg
// module id = DyQm
// module chunks = 258